// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading-spinner":"button__loading-spinner___15Rl0","loadingSpinner":"button__loading-spinner___15Rl0","btn-spinner-rotating":"button__btn-spinner-rotating___1pvoB","btnSpinnerRotating":"button__btn-spinner-rotating___1pvoB","hidden-text":"button__hidden-text___gNFrk","hiddenText":"button__hidden-text___gNFrk","button":"button__button___nvhlp","ghost":"button__ghost___3KGTq","text":"button__text___1Gjjb","blocked":"button__blocked___3xpTV"};
    if(module.hot) {
      // 1789347465583
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  